/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Fiktivbeginnstufe12Inputs */



/**

* @param {_Field_Fiktivbeginnstufe12Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_fiktivbeginnstufe12 = /** @type {((inputs?: _Field_Fiktivbeginnstufe12Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Fiktivbeginnstufe12Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Fiktiv Beginn Stufe 1")
});
export { _field_fiktivbeginnstufe12 as "_field_fiktivBeginnStufe1" }